export const ProductStyles = {
  MainBannerBox: {
    position: "relative",
    overflow: "hidden",
    padding: "30px 35px",
    textAlign: "center",
    "& .leftShade1": {
      position: "relative",
      zIndex: 999,
      boxShadow: "39px -9px 60px 49px #000000",
    },
    "& video": {
      objectFit: "cover",
      width: "100vw",
      height: "100vh",
      position: "absolute",
      top: 0,
      left: 0,
    },
  },
  TitleTxt: {
    fontWeight: 600,
    fontSize: "2rem",
    background: "linear-gradient(93.14deg, #FF8C00, #FF4500)",
    WebkitBackgroundClip: "text",
    display: "inline-block",
    fontFamily: '"Poppins", serif',
    WebkitTextFillColor: "transparent",
    textTransform: "uppercase",
  },
  SpinnerImg: {
    width: 380,
    height: 380,
    marginTop: 40,
    marginBottom: 40,
  },
  SpinnerImgNew: {
    width: 420,
    height: 420,
    marginTop: 40,
    marginBottom: 40,
  },
  IAGSpinner: {
    // width: "70%",
    // height: "auto",
    // maxWidth: "70%",
    // height: "auto",
    width: 350,
    // height: 300,
    objectFit: "contain",
    marginTop: 10,
    marginBottom: 10,
  },
  DescriptionTxt: {
    width: "70%",
    color: "grey",
    fontSize: "1rem",
    fontWeight: 400,
    alignItems: "center",
    fontFamily: '"Poppins", serif',
    marginTop: 4,
  },
  SubHeadingTxt: {
    // width: "70%",
    color: "grey",
    fontSize: "1.1rem",
    fontWeight: 400,
    alignItems: "center",
    fontFamily: '"Poppins", serif',
    // textAlign: "justify",
  },
  DividerBar: {
    my: 3,
    mx: "auto",
    width: "90%",
    height: "2px",
    border: "none",
    borderRadius: "1px",
    background: "linear-gradient(45deg, #cfd8dc, #cfd8dc)",
  },
};
